import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function authHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * useResetInterviewCooldown — POST /api/admin/interview-sim/{user_id}/reset-cooldown
 *
 * Admin/instructor action: reset a student's interview simulation cooldown so
 * they can start a new session immediately.
 *
 * Response 200: { ok: true, reset_at: string, user_id: string }
 * Response 404: { error_code: "user_not_found" }
 *
 * Yetki: instructor / admin / superadmin
 *
 * NOT — cache invalidation yapılmıyor:
 * Öğrenci availability'si farklı kullanıcı/oturum; instructor browser'ından
 * invalidate edilemez — öğrenci kendi tarafında staleTime ile yakalar.
 * Backend reset anında etkin. Instructor tarafı hook'ları (useInstructorAllReviews
 * vb.) TanStack Query değil raw useState/useEffect tabanlı; invalidateQueries
 * bunları tetikleyemez.
 */
export function useResetInterviewCooldown() {
  return useMutation({
    mutationFn: async (userId) => {
      if (!userId) throw new Error('user_id is required');
      const res = await axios.post(
        `${API}/admin/interview-sim/${userId}/reset-cooldown`,
        {},
        { headers: authHeader() }
      );
      return res.data; // { ok: true, reset_at, user_id }
    },
  });
}
